module.exports = __webpack_public_path__ + "static/slider_temp2-778d03b873ddb5b6b8c473ad72bd8ab3.png";